import { useQuery } from "@tanstack/react-query";
import { getDotdigitalLists } from "../../api/bDotdigitalApi";

export const useGetDotdigitalLists = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["dotdigital-lists", organisationId],
    queryFn: () => getDotdigitalLists(organisationId),
    enabled: !!organisationId && enabled,
    staleTime: 5 * 60 * 1000,
  });
};
